// List of Modals to show
export const MODALS = {
  API: 'api',
  ORDER: 'order',
  DOWNLOAD: 'download',
  SAVE_SEARCH: 'saveSearch',
  SHARE: 'shareSession',
  DOWNLOAD_AOI: 'downloadAoi',
  UPLOAD: 'upload',
} as const;

export type ModalsValueType = (typeof MODALS)[keyof typeof MODALS];
